import * as React from "react";
import { MobXProviderContext, observer } from "mobx-react";
import { Box, Link } from "@material-ui/core";
import axios from "axios";
import { MUIPreloader } from "../../../MUI";
import cx from "classnames";
import InfiniteScroll from "react-infinite-scroller";
import { tl } from "../../../../../utils";

import { FileslistsGroup } from "./FileslistsGroup";

const locales: any = {
  notfound: {
    search: tl("Не найден ни один файл по вашему запросу, "),
    lessons: tl(
      "Если вы загрузите файлы в урок, мы отобразим их список здесь, "
    ),
    students: tl("У учеников нет файлов в ДЗ, "),
    curators: tl("У вас и наставников нет файлов в ДЗ, "),
    private: tl("В ваших приватных Чатах нет файлов, "),
    group: tl("В ваших групповых Чатах нет файлов, "),
  },
};

interface IProps {
  APIUrl: string;
}

export const FileslistsGroupsList = observer((props: IProps) => {
  const { fsStore, fsCourseStore } = React.useContext(MobXProviderContext);

  const [groups, setGroups] = React.useState([]);
  const [hasMoreGroups, setHasMoreGroups] = React.useState(true);
  const [initialLoad, setInitialLoad] = React.useState(true);

  let _isMounted = true;
  React.useEffect(() => {
    fsStore.setLoading(false);
    fetchData(1);
    return () => {
      _isMounted = false;
      const tooltips = document.querySelectorAll(".b-tooltip");
      Array.prototype.forEach.call(tooltips, function(node: any) {
        node.parentNode.removeChild(node);
      });
    };
  }, []);

  const fetchData = async (page: number) => {
    if (fsStore.isLoading) {
      return;
    }
    fsStore.setLoading(true);
    setInitialLoad(false);
    // кол-во "групп" (уроков / пользователей / чатов), загружаемых за раз
    const limit = 10;
    let url = props.APIUrl;
    url += fsStore.student_id ? "&student_id=" + fsStore.student_id : "";
    url += `&page_group=${page}&limit_group=${limit}&limit=${fsCourseStore.getFileslistLimit}`;

    axios
      .get(url, {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      })
      .then((response) => {
        if (_isMounted) {
          const newData = response.data;
          const newGroups = [...groups];
          if (newData.groups) {
            newData.groups.map((group: any) => {
              if (
                !newGroups.filter((item: any) => item.id === group.id).length
              ) {
                newGroups.push(group);
              }
            });
            setGroups(newGroups);
            setHasMoreGroups(newData.groups.length >= limit);
            fsStore.setLoading(false);
          } else {
            setHasMoreGroups(false);
            fsStore.setLoading(false);
          }
        } else {
          fsStore.setLoading(false);
        }
      });
  };

  const serachLabel = fsCourseStore.isSearchNotEmpty
    ? "search"
    : fsCourseStore.filesSection === "lessons"
    ? "lessons"
    : fsCourseStore.filesSectionTab
    ? fsCourseStore.filesSectionTab
    : "search";
  return groups.length > 0 ? (
    <Box
      mt={!fsCourseStore.isFileslistCarded ? "-1px" : undefined}
      pb={fsCourseStore.isFileslistCarded ? 1 : undefined}
    >
      <InfiniteScroll
        element="span"
        pageStart={1}
        initialLoad={initialLoad}
        useWindow={fsStore.isWidget}
        loadMore={fetchData}
        hasMore={hasMoreGroups}
        loader={
          <MUIPreloader key="filestorage-fileslist-groupslist-preloader" />
        }
      >
        {groups.map((group: any, i: number, arr: Array<any>) => (
          <FileslistsGroup
            key={`group-${fsCourseStore.filesSection}-${group.id}`}
            group={group}
            APIUrl={fsCourseStore.getFileslistAPIUrl}
          />
        ))}
      </InfiniteScroll>
    </Box>
  ) : hasMoreGroups ? (
    <MUIPreloader />
  ) : (
    <Box px={2} py={3} textAlign="center">
      {locales.notfound[serachLabel]}
      <Link
        underline="always"
        onClick={() => {
          fsCourseStore.isSearchNotEmpty
            ? fsCourseStore.resetFilterParamsSoft()
            : fsCourseStore.resetFilterParams();
        }}
      >
        {tl("вернуться в список файлов")}
      </Link>
      .
    </Box>
  );
});
